module.exports = __webpack_public_path__ + "img/cc.78a55c27.svg";